import React, {useState, useContext} from "react";
import Sugar from 'sugar';

import Accordion from './Accordion'

import SearchResult from "./SearchResult";
import SearchNoResults from "./SearchNoResults";

import { isSameScorecard } from "../Helpers";

Sugar.extend();

function SearchResultList({ majors, highlight, Template, limit, source }) {

  const [current, setCurrent] = useState( null );

  const dataToSearchResult = (data, i) => (
    <Template
      data={data}
      majors={majors}
      highlight={ highlight }
      key={i}
      source={source}
    />
  );

  const display = Math.min( majors.length, limit ) > 0
    ? majors.first(limit).map(dataToSearchResult)
    : <SearchNoResults/>

  return (
    <Accordion isCurrentOpen={ isSameScorecard }>
      {display}
    </Accordion>
  );
}

SearchResultList.defaultProps = {
  template: SearchResult,
  limit: 100
}

export default SearchResultList;
